import { Button, Modal, notification, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { APIEndpointWeb, webapi } from "@client/web";
import {
  CK_ACCESS_DATA_ROLE,
  CK_ACCESS_TOKEN,
  CK_SHARED_TOKEN,
  CK_TYPE,
} from "@constant/constant";
import { useCookies } from "react-cookie";
import { useHistory } from "react-router-dom";
import { AxiosError } from "axios";
import CheckUser from "./CheckUser";

const DashboardLoading: React.FC = (): JSX.Element => {
  const history = useHistory();
  const params = new URLSearchParams(window.location.search);
  const [WindowResize, setWindowResize] = useState(Number);
  const [dataEkyc, setDataEkyc] = useState<any>("");
  const [isModalCheckEkyc, setIsModalCheckEkyc] = useState(false);
  const [checkMessage, setcheckMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [cookies, setCookie] = useCookies([
    CK_TYPE,
    CK_SHARED_TOKEN,
    CK_ACCESS_TOKEN,
    CK_ACCESS_DATA_ROLE,
  ]);
  useEffect(() => {
    let handleWindowResize = () => {
      setWindowResize(window.innerWidth);
    };
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
    var sharedToken = params.get("shared_token");
    if (window.innerWidth < 1024) {
      if (sharedToken) {
        getApiAccessToken(sharedToken);
      } else if (window.innerWidth > 1024) {
        history.replace("/login")
      }
    }
    else {
      history.replace("/login")
    }
  }, [WindowResize]);
  const checkuser = (data: any) => {
    setDataEkyc(data)
    setIsModalCheckEkyc(true)
  };
  function handleMenuClick() {
    history.replace("/login");
  }
  const handleOk = () => {
    setIsModalCheckEkyc(false)
  };
  var checkType = params.get("check-type");
  const getApiAccessToken = async (datashare: string) => {
    try {
      const { data } = await webapi.get(
        `${APIEndpointWeb.GetAccessToken}?shared_token=${datashare}`
      );

      try {
        const dataAccess: any = await webapi.get(`${APIEndpointWeb.GetInfo}`, {
          // headers: { Authorization: `Bearer ${data.result.token}` },
          withCredentials: true,
        });
        // setCookie(CK_SHARED_TOKEN, data.result?.token, { path: "/", maxAge: 3600 * 24, });
        // setCookie(CK_ACCESS_TOKEN, dataAccess.data?.result?.access_token, { path: "/", maxAge: 3600 * 24, });
        setCookie(CK_ACCESS_DATA_ROLE, dataAccess.data?.result?.user_type, { path: "/", maxAge: 3600 * 24, });
        if (dataAccess.data?.result?.user_type === "User" && cookies.type === 'user' || dataAccess.data?.result?.user_type === "Agent" && cookies.type === 'user') {
          // check ekyc
          try {
            const dataCheck: any = await webapi.get(`${APIEndpointWeb.GetCheckekyc}`,
              {
                withCredentials: true,
                // headers: { Authorization: `Bearer ${data?.result.token}` },
              }
            );
            if (dataCheck.data.result === true && cookies.type === 'user') {
              setCookie(CK_SHARED_TOKEN, data?.result.token, { path: "/", maxAge: 3600 * 24, });
              setCookie(CK_ACCESS_TOKEN, dataAccess.data?.result?.access_token, { path: "/", maxAge: 3600 * 24 });
              if (WindowResize < 1024) {
                history.replace("/request");
              }
              else if (WindowResize >= 1024) {
                history.replace("/request-list");
              }
            }
            else if (dataCheck.data.result === false) {
              checkuser(dataCheck.data.result)
            }
          } catch (error) {
            const err = error as AxiosError;
            setcheckMessage(err.response?.data?.message);
          }
          // check agent
        } else if (dataAccess.data?.result?.user_type === "Agent" && checkType === 'agent') {
          if (dataAccess.data.result.expired === 0) {
            history.replace("/newpassword-expiredcode")
          } else {
            history.replace("/send-request");
            // history.replace("/dashboard-insurance");
            setCookie(CK_SHARED_TOKEN, data?.result.token, { path: "/", maxAge: 3600 * 24, });
            setCookie(CK_ACCESS_TOKEN, dataAccess.data?.result?.access_token, { path: "/", maxAge: 3600 * 24 });
          }
        }
        else if (dataAccess.data?.result?.user_type === "Med" && checkType === 'med') {
          setCookie(CK_SHARED_TOKEN, data?.result.token, { path: "/", maxAge: 3600 * 24, });
          setCookie(CK_ACCESS_TOKEN, dataAccess.data?.result?.access_token, { path: "/", maxAge: 3600 * 24 });
          history.replace("/medical-pending");
        }
        else if (cookies.type !== 'agent' || cookies.type !== 'user' || cookies.type !== 'med') {
          Modal.error({
            title: "กรุณาเลือกรูปแบบการเข้าใช้งาน",
            okText: "ตกลง",
            okButtonProps: {
              type: "primary",
            },
            cancelButtonProps: {
              type: "default",
            },
            onOk() {
              setTimeout(() => {
                handleMenuClick()
              }, 1000);
            },
          });
        }
        else {
          Modal.error({
            title: "รหัสผู้ใช้งานของคุณไม่ถูกต้อง",
            content: 'กรุณาลองใหม่อีกครั้ง',
            okText: "ตกลง",
            okButtonProps: {
              type: "primary",
            },
            cancelButtonProps: {
              type: "default",
            },
            onOk() {
              setTimeout(() => {
                // handleMenuClick()
              }, 1000);
            },
          });
        }
        setLoading(false);
        // if (dataAccess.data?.result?.user_type === "User" && checkType === 'user') {
        //   // check ekyc

        //   try {
        //     const dataCheck: any = await webapi.get(`${APIEndpointWeb.GetCheckekyc}`, {
        //       headers: { Authorization: `Bearer ${data.result.token}` },

        //     });
        //     if (dataCheck.data.result === true) {
        //       history.replace("/request");
        //     } else if (dataCheck.data.result === false) {
        //       history.push('/check-user?check-data=' + dataCheck.data.result)
        //     }

        //   } catch (error) {
        //     const err = error as AxiosError;
        //     if (err.response?.data?.message === "Invalid AccountID/AccessToken") {
        //       history.push('/check-user?check-data=' + err.response?.data?.message)
        //     }
        //   }
        //   // check ekyc
        // } else if (dataAccess.data?.result?.user_type === "Agent" && checkType === 'agent') {
        //   history.replace("/send-request");
        // } else if (dataAccess.data?.result?.user_type === "Med" && checkType === 'med') {
        //   history.replace("/medical-pending");
        // } else {
        //   history.replace("/login-type");
        // }
      }
      catch (error) {
        // notification.error({
        //   message: "กรุณาเข้าสู่ระบบใหม่",
        // });
        console.log(error);
      }
    } catch (error) {
      const err = error as AxiosError;
      if (err.response?.data?.message === "Invalid SharedToken") {
        history.push(
          "/check-user?check-data=" + err.response?.data?.message
        );
      }
      if (err.response?.data?.message === "Invalid Data") {
        history.push(
          "/check-user?check-data=" + err.response?.data?.message
        );
      }
    }

  }

  return (
    <>
      <Spin
        tip="กำลังโหลด..."
        style={{ minHeight: '100vh', }}
      >
        <div
          className="g-jutify-align-center"
          style={{
            minHeight: '100vh',
            backgroundColor: '#147F8B'
          }}
        />
      </Spin>
      {/* <Modal
        style={{ height: "50%" }}
        visible={isModalCheckEkyc}
        onCancel={handleOk}
        footer={
          <Button
            type="primary"
            size="middle"
            onClick={handleOk}
          >
            ปิด
          </Button>
        }>
        <CheckUser dataEkyc={dataEkyc} />
      </Modal> */}
    </>
  );
};

export default DashboardLoading;
